import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Button, Card, Badge } from "reactstrap";
import { ENDUSER_LICENSE_DETAILS } from "../../../constants/ApiPaths";
import {
  CUSTOMER_VIEW_LICENSE,
  USER_CREATE_LICENSE,
} from "../../../constants/RoutePaths";
import { authCustomerHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { getCustomerUserId } from "../../common/CommonFunctions";
import CustomTableEmptyRecord from "../../common/CustomTableEmptyRecord";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
export default function Licence() {
  const [licenceDetails, setDetails] = useState([]);
  const [totalRecords, setTotalRecords] = useState("");
  const [currentpage, setCurrentPage] = useState(0);
  const [loading, setloading] = useState(false);
    let rowperpage = 10;

  const userDetails = useSelector((state) => state.AuthUserDetailsReducer);
  const { enqueueSnackbar } = useSnackbar();
  const DeleteAgency = useSelector((state) => state.Agencydelete);

  const history = useNavigate();
  const getLicenceDetails = async () => {
    setloading(true);
    const config = {
      method: "GET",
      url: ENDUSER_LICENSE_DETAILS,
      headers: authCustomerHeader(),
      params: {
        userId: getCustomerUserId(),
        offset: currentpage,
        count: rowperpage,
      },
    };
    try {
      const response = await API(config);
      const { data, totalCount } = response.data;
      setDetails(data);
      setTotalRecords(totalCount);
    } catch (error) {
      console.error(error);
    } finally {
      setloading(false);
    }
  };
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const getTemplateStatus = {
    "License Issued": "warning",
    Pending: "primary",
    "license Generated": "info",
    "License Approved": "success",
    Rejected: "danger",
  };
  const handleNewLicenseClick = () => {
    if (DeleteAgency) {
      return;
    }
    const mandatoryFields = [
      "firstName",
      "lastName",
      "email",
      "phoneNumber",
      "stateName",
      "city",
      "address",
    ];
    const isProfileComplete = mandatoryFields.every((field) =>
      Boolean(userDetails[field])
    );

    if (isProfileComplete) {
      history(USER_CREATE_LICENSE);
    } else {
      CustomAlertMessage(
        "Please update your complete profile information under Settings tab to purchase new licenses.",
        "error",
        enqueueSnackbar
      );
    }
  };

  useEffect(() => {
    getLicenceDetails();
  }, [currentpage]);
  return (
    <Card body className="mt-4">
      {loading && <CustomPageLoading />}
      <div className="create-license-btn" onClick={handleNewLicenseClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="63"
          height="59"
          viewBox="0 0 63 59"
        >
          <g id="Group_115" data-name="Group 115" transform="translate(0.099)">
            <rect
              id="Rectangle_1113"
              data-name="Rectangle 1113"
              width="59"
              height="59"
              rx="29.5"
              transform="translate(-0.099)"
              fill="#1b3e6f"
            />
            <path
              id="Icon_awesome-dog"
              data-name="Icon awesome-dog"
              d="M26.905,5.722H23.434l-.388-.776a1.736,1.736,0,0,0-1.552-.96H18.584L17.1,2.506a.868.868,0,0,0-1.482.614v8.128l6.943,2.48V11.8H24.3a3.471,3.471,0,0,0,3.472-3.472V6.59A.868.868,0,0,0,26.905,5.722Zm-6.075,2.6a.868.868,0,1,1,.868-.868A.868.868,0,0,1,20.83,8.325ZM5.207,12.665a1.738,1.738,0,0,1-1.736-1.736,1.736,1.736,0,0,0-3.472,0,5.2,5.2,0,0,0,3.472,4.887v11.6a.868.868,0,0,0,.868.868H7.811a.868.868,0,0,0,.868-.868V21.344h8.679V27.42a.868.868,0,0,0,.868.868H21.7a.868.868,0,0,0,.868-.868V15.57l-8.134-2.9Z"
              transform="translate(15.896 14.487)"
              fill="#fff"
            />
            <circle
              id="Ellipse_19"
              data-name="Ellipse 19"
              cx="10"
              cy="10"
              r="10"
              transform="translate(42.901 39)"
              fill="#dae0e8"
            />
            <path
              id="Icon_ionic-ios-add"
              data-name="Icon ionic-ios-add"
              d="M17.12,12.772H13.855V9.506a.541.541,0,1,0-1.083,0v3.266H9.506a.541.541,0,0,0,0,1.083h3.266V17.12a.541.541,0,1,0,1.083,0V13.855H17.12a.541.541,0,1,0,0-1.083Z"
              transform="translate(40.068 35.908)"
              fill="#1b3e6f"
            />
          </g>
        </svg>

        <h4>Get New License</h4>
      </div>

      <div className="license-card">
        <Row>
          {licenceDetails && licenceDetails.length > 0 ? (
            licenceDetails.map((record, index) => {
              const {
                planName,
                validFromDate,
                validToDate,
                createdDate,
                licenseStatus,
                licensePlanId,
                dogLicenseId,
              } = record;
              return (
                <Col
                  md="6"
                  lg="6"
                  xl="6"
                  className="mb-3"
                  key={`licence_${index}`}
                >
                  <div className="license-box">
                    <h4>{planName}</h4>

                    <div className="mt-4">
                      <div>
                        {validFromDate && (
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">validate from</h6>
                            </div>
                            <div class="col-auto">
                              <span className="text-sm">{validFromDate}</span>
                            </div>
                          </div>
                        )}
                        <hr className="my-2" />
                        {validToDate && (
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">validate To</h6>
                            </div>
                            <div class="col-auto">
                              <span className="text-sm">{validToDate}</span>
                            </div>
                          </div>
                        )}
                        <hr className="my-2" />
                        <div className="row align-items-center">
                          <div className="col">
                            <h6 className="text-sm mb-0">Purchased date</h6>
                          </div>
                          <div className="col-auto">
                            <span className="text-sm">{createdDate}</span>
                          </div>
                        </div>
                        <hr className="my-2" />
                      </div>
                    </div>

                    <Badge
                      color={getTemplateStatus[licenseStatus]}
                      className="mr-3"
                    >
                      {licenseStatus}
                    </Badge>

                    <div className="centerBtn">
                      <Link
                        to={{
                          pathname: `${CUSTOMER_VIEW_LICENSE}/${licensePlanId}/${dogLicenseId}`,
                        }}
                      >
                        <Button
                          className="action-item"
                          color="primary"
                          size="sm"
                        >
                          View
                        </Button>
                      </Link>
                    </div>
                  </div>
                </Col>
              );
            })
          ) : (
            <CustomTableEmptyRecord />
          )}
        </Row>
        <div className="d-flex flex-row py-4 justify-content-end">
          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            activePage={currentpage + 1}
            itemsCountPerPage={rowperpage}
            totalItemsCount={totalRecords}
            onChange={onPageChange}
          />
        </div>
      </div>
    </Card>
  );
}
